import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { PMS_ROUTE, PmsProvider } from './pms.constants'

export interface PmsCompany {
  id: number
  name: string
}

export const USE_GET_PMS_COMPANIES_QUERY_KEY = 'useGetPmsCompanies'

const PMS_COMPANIES_LIMIT = 1000

export const getPmsCompanies = async (provider: PmsProvider, signal?: AbortSignal) => {
  const response = await authAPI.get<PmsCompany[]>(`/${PMS_ROUTE[provider]}`, {
    params: { limit: PMS_COMPANIES_LIMIT },
    signal,
  })
  return response.data
}

export const useGetPmsCompanies = (provider: PmsProvider | null | undefined) =>
  useQuery({
    enabled: !!provider && provider !== 'resman',
    queryFn: ({ signal }) => getPmsCompanies(provider as PmsProvider, signal),
    queryKey: [USE_GET_PMS_COMPANIES_QUERY_KEY, provider],
  })

export const useInvalidatePmsCompanies = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: [USE_GET_PMS_COMPANIES_QUERY_KEY] })
}
